export const SHOW_ALERT = "SHOW_ALERT"
export const HIDE_ALERT = "HIDE_ALERT"

export const show_alert = (data) => {
    return {type: SHOW_ALERT, data}
}

export const hide_alert = (data) => {
    return {type: HIDE_ALERT, data}
}